export const commonFilter = {
  filters: {
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-end',
    marginBottom: '1em',
    rowGap: '1em',
    '& > *:not(:last-child)': {
      marginRight: '2em',
    },
  },
  filtersActionButton: {
    marginBottom: '.5em',
    '& > *:not(:last-child)': {
      marginRight: '1em',
    },
  },
};

export const commonActionHeader = theme => ({
  actionHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  actionHeaderButton: {
    marginBottom: theme.spacing(1),
  },
});

export const separations = {
  separationBetween: {
    display: 'flex',
    flexDirection: 'row',
    '& > *:not(:last-child)': {
      marginRight: '1em',
    },
  },
  topSeparation: {
    marginTop: '1em',
  },
  bottomSeparation: {
    marginBottom: '1em',
  },
  lineSpacingSeparation: {
    marginTop: '1em',
    marginBottom: '1em',
  },
};

export const centeredCell = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const NoneArrow = () => {
  return <></>;
};
